module.exports = __webpack_public_path__ + "static/media/poll.e1092459.svg";